<template>
  <div v-if="isOpen&&Number(proCatalog)!==75&&Number(proCatalog)!==74&&Number(proCatalog)!==73">
    <div class="commission" @click="showDrawer">
      佣金助手
      <img src="../../../assets/images/commission-icon.png" class="commission-icon">
    </div>
    <a-drawer
      title="佣金助手"
      :width="600"
      :visible="drawerVisible"
      :body-style="{ paddingBottom: '80px' }"
      @close="onClose"
    >
      <a-table rowKey="groupId" :pagination="false" :columns="columns" :data-source="dataList">
            <span slot="groupCommission" slot-scope="text, record, index">
              <a-input-number style="width: 150px;" v-model="dataList[index].groupCommission" :min="0" :max="10000"
                              :precision="2" placeholder="请输入"/>
          </span>
        <span slot="action" slot-scope="text, record, index">
              <a @click="newGroup(2,index)">编辑</a>
              <a style="margin-left: 10px;" @click="deleteGroup(record)">删除</a>
          </span>
      </a-table>
      <a-button @click="newGroup(1)" style="width: 100%;margin: 20px 0;" icon="plus" type="dashed">
        添加分组
      </a-button>
      <div class="bottom-button">
        <a-button :style="{ marginRight: '8px' }" @click="onClose">
          取消
        </a-button>
        <a-button type="primary" @click="onSubmit">
          确定
        </a-button>
      </div>
    </a-drawer>
    <a-modal title="选择分销员分组" :footer="null" :width="650"
             :visible="staffGroupVisible" @cancel="staffGroupVisible = false">
      <custom-page-table
        ref="tableGroup"
        :columns="columnsGroup"
        :queryParams="queryGroup"
        :requestPromise="getRequestPromiseGroup">
        >
        <span slot="action" slot-scope="rowItem">
            <a-button type="primary" size="small" @click="selectStaffGroup(rowItem.record)">选择</a-button>
          </span>
      </custom-page-table>
    </a-modal>
  </div>
</template>

<script>
export default {
  name: 'commissionComponent',
  props: {
    selectedDateList: {
      type: Array,
      default: () => {
        return []
      }
    },
    priceDataList: {
      type: Array,
      default: () => {
        return []
      }
    },
    proCatalog: {
      type: String | Number,
      default: ''
    },
    optionId: {
      type: String | Number,
      default: ''
    },
    ratePlanId: {
      type: String | Number,
      default: ''
    },
    proId: {
      type: String | Number,
      default: ''
    }
  },
  data() {
    return {
      drawerVisible: false,
      data: [],
      columns: [
        {
          title: '成员分组',
          dataIndex: 'groupName'
        },
        {
          title: '设置佣金',
          dataIndex: 'groupCommission',
          scopedSlots: { customRender: 'groupCommission' }
        },
        {
          title: '操作',
          dataIndex: 'action',
          scopedSlots: { customRender: 'action' },
          fixed: 'right'
        }
      ],
      dataList: [],
      editOrSave: '',
      editIndex: '',
      staffGroupVisible: false,
      columnsGroup: [
        {
          title: 'ID',
          dataIndex: 'dataId'
        },
        {
          title: '分组名称',
          dataIndex: 'name'
        },
        {
          title: '分组类型',
          dataIndex: 'catalogStr'
        },
        {
          title: '操作',
          dataIndex: 'action',
          scopedSlots: { customRender: 'action' },
          fixed: 'right'
        }
      ],
      queryGroup: {
        groupIdList: null,
        ruleType: 7
      },
      isOpen: false
    }
  },
  mounted() {
    this.isBuy()
  },
  watch: {
    dataList(v) {
      this.changeDataList(v)
    }
  },
  methods: {
    changeDataList(list) {
      let arr = []
      if (list && list.length > 0) {
        arr = list.map((item) => {
          return item.groupId
        })
      }
      this.queryGroup.groupIdList = arr && arr.length > 0 ? arr : null
    },
    isBuy() {
      let params = {
        merchantId: this.$store.getters.userInfo.merchantId,
        platformId: this.getPlatformConfig().platformId,
        serverUniqueId: 100011
      }
      this.getHttpServices().getServerApiService().post('order/queryServerOpenInfo', params)
        .then(res => {
          this.isOpen = res
        })
        .catch(reason => this.showNetWorkErrorMessage(reason))
    },
    getDateList(date) {
      let arr = []
      if (date && date.length > 0) {
        date.forEach((item) => {
          let obj = {
            date: item
          }
          arr.push(obj)
        })
      }
      return arr
    },
    onSubmit() {
      if (this.dataList && this.dataList.length > 0) {
        for (let i = 0; i < this.dataList.length; i++) {
          if (this.dataList[i].groupCommission === null) {
            this.$message.error('请设置佣金')
            return false
          }
        }
      }
      this.saveData()
    },
    saveData() {
      let params = {
        optionId: this.optionId ? this.optionId : null,
        proCatalog: this.proCatalog,
        proId: this.proId,
        ratePlanId: this.ratePlanId ? this.ratePlanId : null,
        commissionCalendarList: Number(this.proCatalog) === 3 || Number(this.proCatalog) === 8 ? [{ date: '3019-01-01' }] : this.getDateList(this.selectedDateList),
        groupCommissionList: this.dataList && this.dataList.length > 0 ? this.dataList : null
      }
      this.getHttpServices()
        .getPayApiService()
        .post('commissionRule/save/calendar/commission', params)
        .then(res => {
          this.$message.success('成功保存')
          this.drawerVisible = false
        })
        .catch(reason => this.showNetWorkErrorMessage(reason))
    },
    goCommissionRule() {
      let query = {
        serverId: 10,
        serverUniqueId: 100011
      }
      this.openNewPage('CommissionRule', query)
    },
    getCalendarCommission() {
      let dateList = this.selectedDateList
      let params = {
        optionId: this.optionId,
        proId: this.proId,
        ratePlanId: this.ratePlanId ? this.ratePlanId : null,
        date: Number(this.proCatalog) === 3 || Number(this.proCatalog) === 8 ? '3019-01-01' : (dateList && dateList.length > 0) ? dateList[dateList.length - 1] : ''
      }
      this.getHttpServices()
        .getPayApiService()
        .post('commissionRule/get/calendar/commission', params)
        .then(res => {
          this.dataList = res
        })
        .catch(reason => this.showNetWorkErrorMessage(reason))
    },
    newGroup(type, index) {
      this.editOrSave = type
      this.editIndex = index
      this.staffGroupVisible = true
      this.$nextTick(() => {
        this.$refs.tableGroup.refresh(true)
      })
    },

    deleteGroup(record) {
      let arr = this.dataList.filter(item => item.groupId !== record.groupId)
      this.dataList = [...arr]
    },
    selectStaffGroup(obj) {
      if (this.editOrSave === 1) {
        let params = {
          groupId: obj.dataId,
          groupCommission: null,
          groupName: obj.name
        }
        this.dataList.push(params)
      } else {
        this.dataList[this.editIndex].groupId = obj.dataId
        this.dataList[this.editIndex].groupName = obj.name
        this.changeDataList(this.dataList)
      }
      this.staffGroupVisible = false
    },
    onClose() {
      this.drawerVisible = false
    },
    showDrawer() {
      if ((this.selectedDateList && this.selectedDateList.length > 0)) {
        if (this.priceDataList && this.priceDataList.length > 0) {
          for (let i = 0; i < this.selectedDateList.length; i++) {
            let findIndex = this.priceDataList.findIndex(item => {
              return this.selectedDateList[i] === item.priceDate
            })
            if (findIndex < 0) {
              this.$message.error('请选择正确的日期')
              return false
            }
          }
          this.drawerVisible = true
          this.getCalendarCommission()
        } else {
          this.$message.error('请选择正确的日期')
        }
      } else if (Number(this.proCatalog) === 3 || Number(this.proCatalog) === 8) {
        this.drawerVisible = true
        this.getCalendarCommission()
      } else {
        this.$message.error('请选择日期')
      }
    },
    getRequestPromiseGroup(params) {
      return this.getHttpServices().getUserService().post('merchant/v2/group/getCommissionGroupList', params)
    }
  }
}
</script>

<style lang="less" scoped>
.commission {
  padding: 10px;
  position: fixed;
  right: 10px;
  bottom: 120px;
  width: 41px;
  border-radius: 5px 0 0 5px;
  background: rgba(0, 141, 255, 1);
  font-size: 13px;
  text-align: center;
  color: #ffffff;

  .commission-icon {
    width: 21px;
  }
}

.bottom-button {
  position: absolute;
  right: 0;
  bottom: 0;
  width: 100%;
  border-top: 1px solid #e9e9e9;
  padding: 10px 16px;
  background: #fff;
  text-align: right;
  z-index: 1;
}
</style>